// @flow
import * as d3 from 'd3';
import $ from 'jquery'
import 'bootstrap';
import Graph from './Graph';
import type { DataType } from './Types';


var graphsA = d3.selectAll('.graph');

graphsA.attr("class", "graphdone"); // to prevent matching when the next tab loads (double graphs)

graphsA.each(function(this: any) {
  const graph : Graph = new Graph(this);
  const compound_id = d3.select(this).attr('data-compound-id');
  const measurement = d3.select(this).attr('data-measurement'); //mg/L -- 1recieve
  const measurementc = d3.select(this).attr('data-measurementc'); // compound units -- 1recieve 
  const measurementw = d3.select(this).attr('data-measurementw'); //wanted units -- 1recieve 
  const compound_name = d3.select(this).attr('data-compound_abbreviation_wo_medium'); //'data-compound_name' 

  const multic_csv = d3.select(this).attr('data-multic_csv'); // -- multiples allowed
  const multiw_csv = d3.select(this).attr('data-multiw_csv'); // -- multiples allowed
  const multinames_csv = d3.select(this).attr('data-multinames_csv'); // -- multiples allowed

  // if there are additional multi/"combo" measurements, send only to render. graph.json does not need to know about them
  let measurementc2 = measurementc;
  let measurementw2 = measurementw;
  let names_csv = compound_name; // use compound_name for first one -- no combo guideline name
  if (multic_csv != "")
  {
    names_csv += ";" + multinames_csv
    measurementc2 += ";" + multic_csv;
    measurementw2 += ";" + multiw_csv;
  }

  const unitw = d3.select(this).attr('data-unitw'); //wantunit in what format?
  const unitw_id = d3.select(this).attr('data-unitw-id'); //wantunit in what format?

  // send these so that we can generate the lab's DL as a line on the graph with the other benchmarks
  const myDL = d3.select(this).attr('data-myDL'); //mg/L -- part 2 of 1recieve
  const myDLc = d3.select(this).attr('data-myDLc');
  const myDLw = d3.select(this).attr('data-myDLw');

  d3.json(`/report/graph.json?measurementc=${measurementc}&myDLc=${myDLc}&myDLw=${myDLw}&compound_id=${compound_id}&unitw=${unitw}&unitw_id=${unitw_id}`).then((data : DataType) => graph.rendergraph(data, names_csv, measurementc2, measurementw2, unitw)); // mg/L -- 2send
});

// Turn on Bootstrap tooltips and target from the body
// element to it will still effect dynamically added elements
$("body").tooltip({
  container: 'body',
  selector: "[data-toggle='tooltip']"
});

/*
// NEW: MOVED TO this.add_popovers()
// OLD
$("body").popover({
  html: true,
  container: 'body',
  selector: "[data-toggle='popover']",
  trigger: 'hover'
});
*/

